export default onPageTransitionEnd;

function onPageTransitionEnd(pageContext: Vike.PageContext) {
  if (typeof document !== 'undefined') {
    const html = document.documentElement;
    const body = document.querySelector('body');

    const pathnameOriginal = pageContext.urlOriginal || pageContext.urlParsed?.pathnameOriginal;
    const pathname = pageContext.urlPathname || pageContext.urlParsed?.pathname;

    body!.classList.remove('page-is-transitioning');

    document.getElementById('transitionstyle')?.remove();

    if (html!.dataset.nextUrl === pathnameOriginal) {
      html!.dataset.nextUrl = undefined;
    }

    html!.dataset.urlOriginal = pathnameOriginal;
    html!.dataset.urlPathname = pathname;

    if (
      pathnameOriginal === pathname &&
      (pageContext as unknown as { _comesDirectlyFromServer: boolean })._comesDirectlyFromServer
    ) {
      console.log('same');
      // navigate(data.urlPathname);
    }
  }
}
